import $ from 'jquery';
import _ from 'lodash';
import Mustache from 'mustache';
import Cookies from 'js-cookie';

import imgReady from './plugins/imgReady';
import addressData from './helpers/mumuso-ddress';

// 图片设置横向或竖向
document.addEventListener('DOMContentLoaded', function () {
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-direction]'),
    function (el) {
      const img = el.querySelector('img');
      const value = Number(el.getAttribute('data-direction-value')) || 1.25
      const imgUrl = img.getAttribute('src');

      imgReady(imgUrl, function () {
        if ((this.width / this.height) > value) {
          el.setAttribute('data-direction', 'horizontal');
        } else {
          el.setAttribute('data-direction', 'vertical');
        }
      })
    }
  );
})

/**
 * 根据 options 数据生成对应 html 模板
 * @param {array} options
 *
 * @returns {string} html string
 */
const renderOptions = (options) => {
  const template = $('#template-options').html();
  Mustache.parse(template);
  return Mustache.render(template, { options })
}

/**
 * 根据数据填入对应 select 选择项和地址
 * @param {object} selectedArea
 *
 * @param { string } selectAddress.area - 区域
 * @param { array } selectAddress.shops - 商铺
 */
const renderAddress = (selectedArea) => {
  const shops = _.map(selectedArea.shops, item => item.shop);

  $('.address .shop select').html(renderOptions(shops));
  $('.address-info').html(selectedArea.shops[0].address);
}

const queryDiscountCode = () => {
  $.post({
    url: 'http://1.headlines.pw/v1/mumuso/get_mumuso_coupon',
    data: JSON.stringify({
      uid: Cookies.get('uid'),
      did: Cookies.get('did'),
      client: Cookies.get('client'),
      version: Cookies.get('version'),
      flavor: Cookies.get('flavor'),
    }),
    success: function(res) {
      const code = _.get(res, 'data.coupon_no');
      if (code) {
        $('.discount-code').html(code);
      }
    }
  })
}

$(function() {
  const $areaSelect = $('.address .area select');
  const $shopSelect = $('.address .shop select');

  queryDiscountCode();

  const areas = _.map(addressData, (item) => item.area);
  const defaultAddress = _.find(addressData, { area: areas[0] });

  $areaSelect.html(renderOptions(areas));
  renderAddress(defaultAddress);

  $('.page__main').css({ paddingBottom: $('.mumuso-tip').height() + 80 })

  $areaSelect.on('change', function(event) {
    const selectAddress = _.find(addressData, { area: event.target.value });

    renderAddress(selectAddress);
  })
  $shopSelect.on('change', function(event) {
    const selectAddress = _.find(addressData, { area: $areaSelect.val() });
    const address = _.find(selectAddress.shops, { shop: event.target.value }).address;

    $('.address-info').html(address);
  })
})



// WEBPACK FOOTER //
// ./mumuso.js